import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAcademicTerm as apiDelete } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAcademicTerm() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAcademicTerm, isPending: isDelete } = useMutation({
        mutationFn: (id) => apiDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAcademicTerm, isDelete };
}
